import Bootstrap from '@bootstrap/bootstrap'
import Store from '@store/index'
import Google from '@back.bootstrap/google'
import 'livewire-vue'

// Components 


// Vue
window.App = new Vue({
	i18n,
	store: Store,
	mounted() {
		require('bootstrap')
		require('@js/theme.js')
		require('@js/theme/lottie.js')
	}
}).$mount(document.getElementById('app')) 